import { VALIDATE_ERRORS } from '../../../../../constants/crypto';

export default Object.freeze({
  CERTIFICATE_IS_NOT_TRUSTED: VALIDATE_ERRORS.CERTIFICATE_CHAIN,
  CERTIFICATE_REVOKED: VALIDATE_ERRORS.IS_REVOKED,
  BAD_CERTIFICATE: VALIDATE_ERRORS.CONTROL_SUM,
  BAD_KEY_FORMAT: VALIDATE_ERRORS.IS_GOST,
  BAD_POLICIES: VALIDATE_ERRORS.BAD_POLICIES,
  CERTIFICATE_EXPIRED: VALIDATE_ERRORS.TO_DATE,
  CERTIFICATE_NOT_VALID_YET: VALIDATE_ERRORS.FROM_DATE,
  INN_NEEDED: VALIDATE_ERRORS.INN,
  DIFFERENT_USER_AND_CERTIFICATE_INN: VALIDATE_ERRORS.USER_INN,
});
